import React from "react";
import "./quote.css";
import logo from "./logo.svg";

export default class Basket extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    basketId: "",
    basket: null,
    error: null,
    couponCode: "",  // <-- add this line
    };
  }

 componentDidMount() {
  const urlParams = new URLSearchParams(window.location.search);
  const basketId = urlParams.get("basket_id");
  const coupon = urlParams.get("coupon");

  if (basketId) {
    this.setState(
      {
        basketId,
        couponCode: coupon || "",       // show in the input box
        appliedCoupon: coupon || "",    // actually apply it
      },
      () => this.fetchBasket(basketId, coupon || "")
    );
  }
}

  handleInputChange = (e) => {
    this.setState({ basketId: e.target.value });
  };

handleApplyCoupon = () => {
  const { couponCode, basketId } = this.state;

  if (couponCode.trim() !== "" && basketId.trim() !== "") {
    const applied = couponCode.trim();
    this.setState({ appliedCoupon: applied }, () => {
      this.fetchBasket(basketId, applied); // pass coupon to fetchBasket
    });
  }
};


  handleSubmit = (e) => {
    e.preventDefault();
    const { basketId } = this.state;
    if (basketId.trim() !== "") {
      this.fetchBasket(basketId.trim());
    }
  };

  handleCouponChange = (e) => {
  this.setState({ couponCode: e.target.value });
};

  fetchBasket = async (basketId) => {
    const url = `https://appapi1.fhbrundle.co.uk/api?cmd=basket_share&basket_id=${basketId}&postcode=01&deltype=col&price&coupon=${this.state.couponCode}`;

    try {
      const response = await fetch(url);
      const data = await response.json();

      if (data && Array.isArray(data.basket)) {
        this.setState({ basket: data, error: null });
      } else {
        this.setState({ basket: null, error: "Invalid or empty basket." });
      }
    } catch (err) {
      console.error("Basket fetch failed:", err);
      this.setState({ error: "Failed to fetch basket. Please try again later." });
    }
  };

  render() {
    const { basketId, basket, error } = this.state;

    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
        </header>

        <h2>Basket Lookup</h2>

        {/* Basket Code Input */}
        <form onSubmit={this.handleSubmit} style={{ margin: "20px" }}>
          <input
            type="text"
            placeholder="Enter basket code"
            value={basketId}
            onChange={this.handleInputChange}
            className="form_input"
          />
          <button type="submit" className="lookup_link" style={{ marginLeft: "10px" }}>
            Submit
          </button>
        </form>

        {/* Error or status message */}
        {error && (
          <div style={{ color: "red", marginBottom: "20px" }}>
            {error}
          </div>
        )}

        {/* Basket Rendering */}
        {basket && (
          <>
            <h3>Basket ID: {basket.basket_id}</h3>

            <div className="ProductLanding quote">
              <div className="ProductLandingGrid">
                {basket.basket.map((item, index) => (
                  <div key={index} className="product_table prodlayoutdefault">
                    <div className="product_card_img_container">
                      <a
                        className="product_card_link"
                        href={`https://www.fhbrundle.co.uk/products/${item.product}`}
                      >
                        <img
                          className="product_card_img"
                          src={`https://samsara-web.s3-eu-west-1.amazonaws.com/webimages/${item.product}/${item.product}x140.jpg`}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src =
                              "data:image/svg+xml;base64," +
                              btoa(
                                '<svg xmlns="http://www.w3.org/2000/svg" width="1" height="1"><rect width="1" height="1" fill="white"/></svg>'
                              );
                          }}
                          alt=""
                        />
                      </a>
                    </div>

                    <div className="product_card_content">
                      <div className="product_card_desc">
                        <a
                          className="product_card_link"
                          href={`https://www.fhbrundle.co.uk/products/${item.product}`}
                        >
                          {item.title}
                        </a>
                      </div>
                      <div className="product_card_code">{item.product}</div>

                      {item.notepad && item.notepad !== "@@" && (
                        <div className="product_card_note">
                          {item.notepad.replaceAll("@", "")}
                        </div>
                      )}

                      <div className="product_card_bottom">
                        <div className="prod_price">
                          <div className="quote_item">
                            <div className="quote_label">QUANTITY</div>
                            <div className="quote_value">x{item.quantity}</div>
                          </div>
                          <div className="quote_item">
                            <div className="quote_label">UNIT PRICE</div>
                            <div className="quote_value">
                                {item.discount_applies && item.discounted_unit_price ? (
                                <>
                                    <span style={{ textDecoration: "line-through", marginRight: "5px" }}>
                                    £{parseFloat(item.unit_price).toFixed(2)}
                                    </span>
                                    <strong>£{parseFloat(item.discounted_unit_price).toFixed(2)}</strong>
                                </>
                                ) : (
                                <>£{parseFloat(item.unit_price).toFixed(2)}</>
                                )}
                            </div>
                            </div>
                          <div className="quote_item">
                            <div className="quote_label">LINE TOTAL</div>
                            <div className="quote_value">
                                {item.discount_applies && item.discounted_line_total ? (
                                <>
                                    <span style={{ textDecoration: "line-through", marginRight: "5px" }}>
                                    £{parseFloat(item.line_price).toFixed(2)}
                                    </span>
                                    <strong>£{parseFloat(item.discounted_line_total).toFixed(2)}</strong>
                                </>
                                ) : (
                                <>£{parseFloat(item.line_price).toFixed(2)}</>
                                )}
                            </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Basket Totals */}
          <div className="quote_summary_values"  style={{ margin: "10px" ,padding:"10px",background:"#FFF"}}>
  {basket.coupon_info && basket.coupon_info.valid ? (
    <>
      <div>
        <span className="summary_label">Subtotal (ex VAT):</span>{" "}
        <span style={{ textDecoration: "line-through", marginRight: "5px" }}>
          £{parseFloat(basket.sub_total).toFixed(2)}
        </span>
        <strong>£{parseFloat(basket.coupon_info.new_total).toFixed(2)}</strong>
      </div>

      <div>
        <span className="summary_label">VAT:</span>{" "}
        <span style={{ textDecoration: "line-through", marginRight: "5px" }}>
          £{parseFloat(basket.vat).toFixed(2)}
        </span>
        <strong>£{parseFloat(basket.coupon_info.new_vat).toFixed(2)}</strong>
      </div>

      <div>
        <span className="summary_label">Total (inc VAT):</span>{" "}
        <span style={{ textDecoration: "line-through", marginRight: "5px" }}>
          £{parseFloat(basket.total_incl_vat).toFixed(2)}
        </span>
        <strong>£{parseFloat(basket.coupon_info.new_total_incvat).toFixed(2)}</strong>
      </div>

    {/*  <div style={{ color: "#66ff66", marginTop: "10px" }}>
        <em>{basket.coupon_info.description}</em>
      </div>*/}
    </>
  ) : (
    <>
      <div>
        <span className="summary_label">Subtotal (ex VAT):</span>{" "}
        £{parseFloat(basket.sub_total).toFixed(2)}
      </div>
      <div>
        <span className="summary_label">VAT:</span> £{parseFloat(basket.vat).toFixed(2)}
      </div>
      <div>
        <span className="summary_label">Total (inc VAT):</span>{" "}
        <strong>£{parseFloat(basket.total_incl_vat).toFixed(2)}</strong>
      </div>
    </>
  )}
</div>
          </>
        )}

{basket && (
  <div className="quote_container" style={{ margin: "10px" ,background:"#FFF"}}>
    
    <div style={{ display: "flex", gap: "10px", marginTop: "5px" }}>
        
      <input
        type="text"
        id="couponInput"
        placeholder="Discount code"
        className="form_input"
        value={this.state.couponCode}
        onChange={this.handleCouponChange}
        style={{ maxWidth: "200px" }}
      />
      <button className="discount_button" onClick={this.handleApplyCoupon}>
        Apply
      </button>
    </div>
 {this.state.appliedCoupon &&
 this.state.basket?.coupon_info?.valid && this.state.basket.coupon_info.eligible && (
  <div style={{ marginTop: "5px", color: "#00cc66", fontWeight: "bold" }}>
    Coupon "<strong>{this.state.appliedCoupon}</strong>" applied.<br />
    <span style={{ fontWeight: "normal", fontSize: "0.9em" }}>
      {this.state.basket.coupon_info.description}
    </span>
  </div>
)}

{this.state.appliedCoupon &&
 this.state.basket?.coupon_info?.valid && this.state.basket.coupon_info.eligible === false && (
  <div style={{ marginTop: "5px", color: "#ff9900", fontWeight: "bold" }}>
    Coupon "<strong>{this.state.appliedCoupon}</strong>" is valid but not applicable to this basket.<br />
    <span style={{ fontWeight: "normal", fontSize: "0.9em" }}>
      {this.state.basket.coupon_info.description}
    </span>
  </div>
)}

{this.state.appliedCoupon &&
 this.state.basket?.coupon_info?.valid === false && (
  <div style={{ marginTop: "5px", color: "#cc0000", fontWeight: "bold" }}>
    Coupon "<strong>{this.state.appliedCoupon}</strong>" is invalid.
  </div>
)}
  </div>
)}
        {basket && basket.basket_id && (
  <div className="quote_container">
    <div className="quote_summary">
      <div className="quote_actions">
        <button
  className="pay_button"
  onClick={() => {
    const baseUrl = `https://www.fhbrundle.co.uk/basket?loadBasket=${encodeURIComponent(basket.basket_id)}`;
    const fullUrl = this.state.couponCode.trim()
      ? `${baseUrl}&discount=${encodeURIComponent(this.state.couponCode.trim())}`
      : baseUrl;

    window.location.href = fullUrl;
  }}
>
  Edit Basket Online
</button>
      </div>
    </div>
  </div>
)}

      </div>
    );
  }
}
